/**
 * Прогоняем входящие данные по формуле `(currentValue / parentValue) * 100`
 * @param {number} currentValue обязательный параметр - значение ширины (высоты) текущего блока в пикселях, которому задается значение в процентах.
 * @param {number} parentValue обязательный параметр - значение ширины (высоты) родительского блока в пикселях, на основе которого считаем значение в процентах для текущего блока.
 * @param {boolean} [isProcent=true] необязательный параметр - по умолчанию, добавляем к возвращаемому значению знак `%`, если этот параметр не равен `false`.
 * @returns {(string|number)} возвращает строку вида `n + %` или число `n`, где n - число
 * @description Функция считает процент для блока, когда известны его ширина (высота) и ширина (высота) его родителя.
 */

/**
 * @example
 * // returns '11%;'
 * return(<div css={css`width: ${getPercent(22, 200)}`} />);
 * @example
 * // returns '11%;'
 * const EmotionComponent = styled('a')`
 *  width: ${getPercent(22, 200)};
 * `;
 * @example
 * // returns 11
 * return(<Progress value={+getPercent(22, 200, false)} />);
 */

export const getPercent = (currentValue: number, parentValue: number, isProcent = true) => {
  const calculate = (currentValue / parentValue) * 100;
  return isProcent ? `${calculate}%` : calculate;
};
